import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8943f23c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8943f23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8943f23c')) {
      api.createRecord('8943f23c', component.options)
    } else {
      api.reload('8943f23c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8943f23c&scoped=true", function () {
      api.rerender('8943f23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/virtual/index.vue"
export default component.exports